export default submissionStats =>
  !!(submissionStats.approved !== 0 || submissionStats.rejected !== 0);
